import React, { useState } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { createRoleReq } from "../requests";
import RoleForm from "./RoleForm";

const formName = "roles";
const CreateRole = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {
    let payload = {
      "object": {
        name: data.name,
        is_active: true
      }
    }
    makeRequest(setLoader, createRoleReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("Role Created", res.msg);
    props.onCreated(data.object);
  }

  const onError = (data) => {
    setErrors(data);
  }

  return (
    <DrawerComponent mainTitle="Create" subTitle="Role" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <RoleForm setErrors={ setErrors } errors={ errors } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default CreateRole
